<!--
Copyright (c) 2020-2025 ForgeRock. All rights reserved.

This software may be modified and distributed under the terms
of the MIT license. See the LICENSE file for details.
-->

<template>
    <div :class="[ 'pearson-nav', `${themeName.toLowerCase ()}-nav` ]" v-if="showBrandBadge" style="display: block;">
        <nav>
            <ul>
                <li v-if="themeName === 'QG' || themeName === 'QI' || themeName === 'PCAS'">
                    <img src="@/assets/images/smalllogo.png" alt="Pearson" width="25" height="25"
                         style="border-radius: 100%;">
                    <span id="pearsontext" style="margin-right: 20px; font-size: 18px;">{{ $t('pages.selfservice.passwordReset.pearson') }}</span>
                </li>
                <li v-if="themeName === 'QG'"><span id="navText">{{ $t('pages.selfservice.passwordReset.Qglobal') }}</span></li>
                <li v-if="themeName === 'QI'"><span id="navText">{{ $t('pages.selfservice.passwordReset.Qinteractive') }}</span></li>
                <li class="us-region" v-if="showNavRegion"><span>{{ displayRegion }}</span></li>
            </ul>
        </nav>
    </div>
</template>

<script>
/**
 * @description Pearson Navigation component for use across various pages
 */
import { getClientById } from '../../../lib/getClientById';

export default {
    name: 'PearsonNav',
    props: {
        themeName: {
            type: String,
            default: 'BASE'
        },
        showBrandBadge: {
            type: Boolean,
            default: false
        },
        showNavRegion: {
            type: Boolean,
            default: true
        },
        clientId: {
            type: String,
            default: ''
        }
    },
    computed: {
        currentClientId () {
            // Use provided clientId prop if available, otherwise get it from the utility function
            return this.clientId || getClientById();
        },
        clientRegion () {
            if (this.themeName === 'PCAS' && this.currentClientId && this.currentClientId.startsWith('PCAS')) {
                // Extract the 2 characters after "PCAS" from "PCASXX-Client"
                const match = this.currentClientId.match(/^PCAS([A-Za-z0-9]{2})/);
                if (match && match[1]) {
                    return match[1];
                }
            }
            return null;
        },
        displayRegion () {
            if (this.themeName === 'PCAS' && this.clientRegion) {
                return this.clientRegion.toUpperCase();
            }
            return this.$t('pages.selfservice.passwordReset.us');
        }
    }
};
</script>

<style scoped lang="scss">
/* Styles are imported from pearson-common.css at the page level */
</style>
